import React, { useState, useEffect } from "react";
import { Text, StyleSheet, View, Platform } from "react-native";

import {
  getStorageItem,
  getStorageKey,
  setStorageItem,
} from "../../../../helpers/utils.js";

import cardStyles from "./cardStyles";
import AppTheme from "../../AppTheme";

import CloseIcon from "../../common/dialog/CloseIcon";
import ManaButton from "../../common/ManaButton";
import ImpersonateIcon from "../../common/icons/more/ImpersonateIcon";

export default function ImpersonateCard({ controller, data = {} }) {
  const stopImpersonation = () => {
    controller.apiService.setImpersonate(null);
    controller.setState({
      impersonate: null,
      reflection: null,
      resolutions: null,
      timeslots: null,
      lastCalendarQuery: null,
      calendarItems: null,
      calendarItemsChecksum: null,
      calendarLoginShown: false,
      sequences: null,
      probable_times: null,
      rules: null,
      calendar_prob: null,
      routines: null,
      reflection_root: null,
      sent_reports: null,
      received_reports: null,
      received_aggregated_reports: null,
      teams: null,
      snoozed_cards: null
    });
    controller.getItemsWithStats("feed", "rn:home_card");
  };

  return (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 80 }]}>

        <View style={[cardStyles.header, { paddingHorizontal: 0 }]}>
          <ImpersonateIcon />

          <View style={[cardStyles.headerInfo, { marginLeft: 6 }]}>
            <Text style={cardStyles.title}>Impersonating</Text>
          </View>
        </View>

        <View style={styles.content}>
          <Text style={styles.user}>{data.user}</Text>

          <ManaButton
            onPress={stopImpersonation}
            style={[cardStyles.buttonSmall, { minWidth: 60, height: 30 }]}
            styleText={cardStyles.buttonSmallText}
            text="Stop"
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  user: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
});
